function isApplePlatform () {
  return typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
}

export default {
  return: "enter",
  '⇧': "shift",
  '⌃': "ctrl",
  '⌘': "meta",
  '⌥': "alt",
  'pause/break': "pause",
  break: "pause",
  caps: "capslock",
  cmd: "meta",
  command: "meta",
  control: "ctrl",
  ctl: "ctrl",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  leftcommand: "meta",
  mycalculator: "launchcalculator",
  mycomputer: "launchmycomputer",
  'numpad-': "subtract",
  'numpad.': "separator",
  'numpad*': "multiply",
  'numpad/': "divide",
  'numpad+': "add",
  numpad0: "0",
  numpad1: "1",
  numpad2: "2",
  numpad3: "3",
  numpad4: "4",
  numpad5: "5",
  numpad6: "6",
  numpad7: "7",
  numpad8: "8",
  numpad9: "9",
  numpadadd: "add",
  option: "alt",
  pgdn: "pagedown",
  pgup: "pageup",
  right: "arrowright",
  rightcommand: "meta",
  space: " ",
  spc: " ",
  up: "arrowup",
  windows: "meta",
  mod: isApplePlatform() ? 'meta' : 'ctrl',
}
